import React from 'react';
import { Icon } from '@iconify/react';

// Icon mapping with proper Iconify icon names
const iconMap: Record<string, string> = {
  // Brand
  zap: 'mdi:lightning-bolt',
  gavel: 'mdi:gavel',
  scale: 'mdi:scale-bathroom',

  // Chat & AI
  message: 'mdi:message-text',
  bot: 'mdi:robot',
  brain: 'mdi:brain',
  sparkle: 'mdi:star-four-points',

  // Documents
  document: 'mdi:file-document',
  fileUpload: 'mdi:upload',
  fileDownload: 'mdi:download',

  // Finance & Tokens
  coin: 'mdi:coin',
  creditCard: 'mdi:credit-card',
  gift: 'mdi:gift',
  trending: 'mdi:trending-up',

  // Actions
  send: 'mdi:send',
  plus: 'mdi:plus',
  settings: 'mdi:cog',
  logout: 'mdi:logout',
  user: 'mdi:account',
  bell: 'mdi:bell',
  chevronRight: 'mdi:chevron-right',
  trash: 'mdi:trash-can',
  refresh: 'mdi:refresh',

  // Legal extras
  shield: 'mdi:shield-check',
  alert: 'mdi:alert-circle',

  // Fun
  play: 'mdi:play',
};

type IconName = keyof typeof iconMap;

interface IconProps {
  name: IconName;
  className?: string;
}

export const NotLegalIcon: React.FC<IconProps> = ({ name, className }) => {
  const icon = iconMap[name];
  if (!icon) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  return <Icon icon={icon} className={className} />;
};
